
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowDtoModel extends Model<TaskflowDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflow', type: 'TaskflowModel', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'productPlanIds', type: 'string[]', isArray: true },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'title', type: 'string' },
		{ name: 'description', type: 'string' },
		{ name: 'deadline', type: 'Date' },
		{ name: 'userId', type: 'string' }
	];
	[key: string]: any;
	
	public taskflow?: TaskflowModel;
	public productPlanIds: string[];
	public productPlanId?: string;
	public title: string;
	public description: string;
	public deadline?: Date;
	public userId?: string;
    
	constructor(){
		super();
		this.taskflow = undefined;
		this.productPlanIds = [];
		this.productPlanId = undefined;
		this.title = '';
		this.description = '';
		this.deadline = undefined;
		this.userId = undefined;
		
	}
	getProperties(){
		return TaskflowDtoModel.classProperties;
	}
}

